import * as go from 'gojs';
import { subGraphExpanderImageButton } from '../../../../parts/subgraph-expander-image-button';
import { sidebarNodeTypes } from '../../config/config';
import {
  locationBinding,
  nodeGroupDescriptionBinding,
  nodeGroupTitleBinding,
  subGraphExpandedBinding,
} from '../common/utils/bindings';
import { CustomTextEditor } from './../common/parts/text-editor';
import { lockedBindings, zOrderBindings } from './../common/utils/bindings';
import { CustomNodeGroupLayout } from './utils/group-layout';
import { finishDrop, highlightGroup, sidebarMemberValidation } from './utils/group-utils';

const $ = go.GraphObject.make;

const movable = true;

export const nodeGroupNodeTemplate = (): go.Group =>
  $(
    go.Group,
    go.Group.Auto,
    {
      ungroupable: true,
      handlesDragDropForMembers: true,
      computesBoundsAfterDrag: true,
      isLayoutPositioned: false,
      locationSpot: go.Spot.TopLeft,
      layout: $(CustomNodeGroupLayout, {
        isOngoing: false,
        isRealtime: false,
        isInitial: false,
      }),
      background: 'transparent',
      memberValidation: sidebarMemberValidation,
      mouseDrop: ((e: go.InputEvent, group: go.Group) => finishDrop(e, group, sidebarNodeTypes.nodeGroupNode)) as (
        e: go.InputEvent,
        thisObj: go.GraphObject,
      ) => void,
      mouseDragEnter: (e: go.InputEvent, grp: go.GraphObject, prev: go.GraphObject) => highlightGroup(e, grp, true),
      mouseDragLeave: (e: go.InputEvent, grp: go.GraphObject, next: go.GraphObject) => highlightGroup(e, grp, false),
    },
    shape(),
    groupContainer(),
    locationBinding(),
    subGraphExpandedBinding(),
    ...zOrderBindings(),
    ...lockedBindings({ movable }),
  );

const shape = () =>
  $(
    go.Shape,
    'RoundedRectangle',
    {
      stroke: '#D9D9D9',
      strokeWidth: 1,
    },
    new go.Binding('fill', 'isHighlighted', (isHighlighted) =>
      isHighlighted ? 'rgb(255, 241, 204)' : 'rgba(255, 241, 204, 0.6)',
    ).ofObject(),
  );

const groupContainer = () => $(go.Panel, go.Panel.Vertical, groupHeader(), groupDescription(), placeholder());

const placeholder = () => $(go.Placeholder, { padding: new go.Margin(40, 20), alignment: go.Spot.TopLeft });

const groupHeader = (): go.Panel =>
  $(
    go.Panel,
    go.Panel.Horizontal,
    { stretch: go.GraphObject.Horizontal },
    subGraphExpanderImageButton(),
    $(
      go.TextBlock,
      {
        alignment: go.Spot.Left,
        editable: true,
        margin: new go.Margin(5, 25, 0, 4),
        font: 'normal 14px sans-serif',
        stroke: '#000000',
        textEditor: $(CustomTextEditor, {
          flexibleWidth: true,
        }),
      },
      nodeGroupTitleBinding(),
    ),
  );

const groupDescription = (): go.Panel =>
  $(
    go.Panel,
    go.Panel.Horizontal,
    { stretch: go.GraphObject.Horizontal },
    $(
      go.TextBlock,
      {
        alignment: go.Spot.Left,
        editable: true,
        margin: new go.Margin(5, 25, 5, 25),
        font: 'normal 10px sans-serif',
        stroke: '#7F7F7F',
        textEditor: $(CustomTextEditor, {
          flexibleWidth: true,
        }),
      },
      nodeGroupDescriptionBinding(),
    ),
  );
